type OffrLogoProps = {
  className?: string;
  markOnly?: boolean;
  priority?: boolean;
};

export function OffrLogo({
  className = "",
  markOnly = false,
  priority = false
}: OffrLogoProps) {
  const asset = markOnly
    ? {
        src: "/brand/offr-mark-ui-128.webp",
        srcSet:
          "/brand/offr-mark-ui-128.webp 128w, /brand/offr-mark-ui-256.webp 256w",
        sizes: "56px",
        width: 128,
        height: 133
      }
    : {
        src: "/brand/offr-wordmark-ui-256.webp",
        srcSet:
          "/brand/offr-wordmark-ui-256.webp 256w, /brand/offr-wordmark-ui-512.webp 512w",
        sizes: "120px",
        width: 256,
        height: 124
      };

  return (
    <span
      className={`offr-logo ${markOnly ? "offr-logo--mark" : "offr-logo--full"} ${className}`.trim()}
      role="img"
      aria-label="Offr"
    >
      <span className="sr-only">Offr</span>
      <img
        className="offr-logo__asset"
        src={asset.src}
        srcSet={asset.srcSet}
        sizes={asset.sizes}
        width={asset.width}
        height={asset.height}
        alt=""
        aria-hidden="true"
        decoding="async"
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
      />
    </span>
  );
}
